import React, { useEffect } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@mui/material";
import CustomerManagementList from "../../../Screens/Customers/CustomerManagementList";
import { Doughnut } from "react-chartjs-2";
import "chart.js/auto";
import { Line } from "react-chartjs-2";
import { Bar } from "react-chartjs-2";
import "../../../styles/admin-panel.scss";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  LineController,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import {
  fetchDashboardDataRequest,
  fetchVendorDashboardDataRequest
} from "../../../redux/Dashboard/DashboardAction";
import { useDispatch, useSelector } from "react-redux";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LineController,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const VendorDashBoard = () => {
  const dispatch = useDispatch();
  const { data, vendorData, loading, error } = useSelector(
    (state) => state.dashboard
  );

  useEffect(() => {
    dispatch(fetchDashboardDataRequest());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchVendorDashboardDataRequest());
  }, [dispatch]);

  const revenueChartData = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    datasets: [
      {
        label: "Total Revenue",
        data: [
          1200, 1500, 1800, 2100, 2300, 3000, 3500, 4000, 4500, 5000, 5500, 6000
        ],
        borderColor: "#ed6c02",
        backgroundColor: "rgba(237, 108, 2, 0.1)",
        pointBackgroundColor: [
          "#525252",
          "#ed6c02",
          "#525252",
          "#ed6c02",
          "#525252",
          "#ed6c02",
          "#525252",
          "#ed6c02",
          "#525252",
          "#ed6c02",
          "#525252",
          "#ed6c02"
        ],
        pointBorderColor: "#fff",
        pointRadius: 6,
        pointHoverRadius: 8,
        tension: 0.4
      }
    ]
  };
  const statisticsData = [
    // { metric: "Total Revenue", value: "$45,678", change: "+20%" },
    { metric: "Total Users", value: data?.count?.usersCount || 0 },
    {
      metric: "Total Bookings",
      value: data?.count?.totalBookingCount || 0
    },
    {
      metric: "Today Cancellations",
      value: data?.count?.todayCancelBookingCount || 0
    }
  ];
  return (
    <Box className="admin-panel-box">
      <Box>
        <Grid container spacing={2} className="vendor-metrics">
          <Grid item xs={12} sm={6} md={4}>
            <Card className="metric-card">
              <CardContent>
                <Typography
                  variant="h6"
                  color="textSecondary"
                  className="metric-title"
                >
                  Total Bookings
                </Typography>
                <Typography variant="h4" className="metric-value-users">
                  {vendorData?.count?.totalBookingCount || 0}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Confirmed:{" "}
                  {vendorData?.count?.totalCompletedBookingCount || 0},
                  Canceled: {vendorData?.count?.totalCancelBookingCount || 0}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Divider className="divider-line" />

          <Grid item xs={12} sm={6} md={4}>
            <Card className="metric-card">
              <CardContent>
                <Typography
                  variant="h6"
                  color="textSecondary"
                  className="metric-title"
                >
                  Total Revenue
                </Typography>
                <Typography variant="h4" className="metric-value-revenue">
                  $45,678{" "}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Monthly Growth: 20%
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Card className="metric-card">
              <CardContent>
                <Typography
                  variant="h6"
                  color="textSecondary"
                  className="metric-title"
                >
                  Payments
                </Typography>
                <Typography variant="h4" className="metric-value-payments">
                  {vendorData?.count?.totalBookingCount || 0}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Refunds: {vendorData?.count?.totalCancelBookingCount || 0}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>

      <Divider className="divider-line" />

      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <Card className="vendor-dashboard-card">
            <CardContent className="vendor-dashboard-card-content">
              <Box className="vendor-dashboard-header">
                <Typography variant="h6" className="vendor-dashboard-title">
                  Total Revenue
                </Typography>
              </Box>
              <Box
                className="vendor-dashboard-chart-container"
                style={{ height: "300px" }}
              >
                <Line
                  data={revenueChartData}
                  options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                      legend: {
                        display: true,
                        position: "top"
                      }
                    },
                    scales: {
                      x: {
                        grid: { display: false }
                      },
                      y: {
                        beginAtZero: true,
                        ticks: {
                          callback: (value) => `$${value}`
                        }
                      }
                    }
                  }}
                />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Divider className="divider-line" />

      <CustomerManagementList />

      <Divider className="divider-line" />
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card sx={{ boxShadow: 5 }}>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                Booking Management
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Total Bookings: {data?.count?.totalBookingCount || 0}
              </Typography>

              <Typography variant="body2" color="textSecondary">
                Total Cancellations: {data?.count?.totalCancelBookingCount || 0}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Total Completed Bookings:{" "}
                {data?.count?.totalCompletedBookingCount || 0}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card sx={{ boxShadow: 5 }}>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                Vendor Management
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Pending Approvals: 3
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Discounts Applied: 10%
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Total Vendors: {data?.count?.vendorsCount || 0}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Divider className="divider-line" />

      <Typography variant="h5" gutterBottom>
        Statistics Reports
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Metric</TableCell>
            <TableCell align="center">Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {statisticsData.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{row.metric}</TableCell>
              <TableCell align="center">{row.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};
export default VendorDashBoard;
